import React from 'react';
import * as LucideIcons from 'lucide-react';

const iconMap = {
  'dashboard': 'LayoutDashboard',
  'group': 'Users',
  'folder_special': 'Folder',
  'view_agenda': 'LayoutList',
  'swap_horiz': 'ArrowLeftRight',
  'directions_car': 'Car',
  'location_city': 'Building2',
  'person': 'User',
  'settings': 'Settings',
  'power_settings_new': 'Power',
  'home': 'Home',
  'menu': 'Menu',
  'chevron_right': 'ChevronRight',
  'search': 'Search',
  'notifications': 'Bell',
  'shopping_cart': 'ShoppingCart',
};

const LucideIcon = ({ name, size = 18, className, ...props }) => {
  const iconName = iconMap[name] || name;
  const IconComponent = LucideIcons[iconName];

  if (!IconComponent) {
    // Fallback to a default icon if not found
    return <LucideIcons.HelpCircle size={size} className={className} {...props} />;
  }

  return <IconComponent size={size} className={className} {...props} />;
};

export default LucideIcon;
